import React  from 'react';
import TableRow from './TableRow'

const TableBody = (props) => {
    const{tarjetas, data, edicionClienteAdicional, borrarClienteAdicional}=props
    const {solicitudCuenta}=tarjetas

    let esCuentaEmpresa= tarjetas.tipoEmpresa.EmpresaIndividuos == "E";

    //SE NECESITA CONOCER EL LIMITE DE COMPRA DE LA CUENTA PARA MOSTRAR QUE PORCENTAJE ES EL ASIGNADO A CADA ADICIONAL
    let limiteFront = 0;

    if(tarjetas.tipoEmpresa.TipoLimite == "L"){
        //SI ES LÍMITE TIPO "L" SE BUSCARÁ EL VALOR DEL LÍMITE PARA EL ID DE LÍMITE ELEGIDO EN LA SOLICITUD DE CUENTA
        tarjetas.solicitudCuenta.GET_ATLAS_LIMITE_COMPRA.map(limite=>{if(limite.Id==tarjetas.solicitudCuenta.limiteCompraId) limiteFront = parseInt(limite.Valor)})
    }else if(tarjetas.tipoEmpresa.TipoLimite =="M"){
        //SINO DIRECTAMENTE EL MONTO
        limiteFront = parseInt(tarjetas.solicitudCuenta.limiteCompra)
    }
    if(tarjetas.esModificacion && tarjetas.solicitudCuenta.SolicitudTipoId == 3 && tarjetas.tipoEmpresa.EmpresaIndividuos =="I"){
        //si se trata de la modificación de una solicitud tipo 3 (tarjeta únicamente) y es una cuenta tipo individuo, hay que quitar de la tabla la tarjeta que ya figura como titular
        let adicionalesAux = [];
        solicitudCuenta.cuentasAdicionales && solicitudCuenta.cuentasAdicionales.map(adic=>{
            if(adic.CategoriaTarjeta != "0") adicionalesAux.push(JSON.parse(JSON.stringify(adic)))
        })
        adicionalesAux.map((ad,index)=>{ad.idAdicional=index+1})
        solicitudCuenta.cuentasAdicionales = adicionalesAux
    }
    
        return (
            <tbody>
                {tarjetas.tipoEmpresa.EmpresaIndividuos =="I" && <TableRow limiteCompraCuenta={limiteFront}  data={data} cliente={"titular"} tarjetas={tarjetas}/>}
                { 
                   solicitudCuenta.cuentasAdicionales&&
                   solicitudCuenta.cuentasAdicionales.map((adicional,index)=> 
                    <TableRow esCuentaEmpresa={esCuentaEmpresa} confirmarClienteTarjeta={props.confirmarClienteTarjeta} numero={index} limiteCompraCuenta={limiteFront}  data={data} cliente={"adicional"} adicionales={solicitudCuenta.cuentasAdicionales} adicional={adicional} tarjetas={tarjetas} edicionClienteAdicional={edicionClienteAdicional}borrarClienteAdicional={borrarClienteAdicional}/>)
                }  
            </tbody>
        )
};

export default TableBody;